import react,{Component} from 'react';
import { DKLabel, DKButton,showToast,TOAST_TYPE, DKSpinner,INPUT_TYPE,DKCalendar,DKIcon,DKIcons,DKLine,DKInput,INPUT_VIEW_DIRECTION,Toggle } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import { FEDERAL_FREQUENCY } from '../../ReportsConstants';
import { DATE_FORMAT, YEAR } from '../../../../constants/Constant';
import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
import moment from 'moment';
import { getCPFYears } from '../../../../managers/common/CommonUtil';
export default class Form944 extends Component{
    selectedYear = [0];
    selectedFedral = [0];
    requiredFormat = DATE_FORMAT.YYYYMMDD;
    federalFrequencyOptions = FEDERAL_FREQUENCY.map(res=>res.value)
    formType = 'FORM944'
    constructor(props){
        super(props)

        this.state = {
            year: getCPFYears(),
            canValidate:false,
            endDate:'',
            startDate: ''
        }

    }
    componentDidMount() {
        this.setQuarterAccountDetails(0)
        RouteManager.setPresenter(this);
    }
    export() {
        this.setState({ ...this.state })
        const year = moment(this.state.startDate, DATE_FORMAT.YYYYMMDD).year();
        let fileName = `${TenantService.get(TENANT.FIRST_NAME)}_${TenantService.get(TENANT.LAST_NAME)} ${this.formType}.pdf`;
        if (year != YEAR.TWO_THOUSAND_NINETEEN) {
            let params = {};
            params["year"] = year
            ReportService.downloadStateForm("FORM944", params).then(
                (response) => {
                    if (response["size"] <= 0) {
                        showToast("Form download failed. Please make sure Tax details are filled and Payrun(s) are processed.", TOAST_TYPE.FAILURE);
                    } else {
                        saveAs(response, fileName);
                    }
                },
                (error) => {
                    showToast("Internal Server Error", TOAST_TYPE.FAILURE);
                }
            );
        } else {
            let users = []

            if (this.selectedYear.length == 0 || this.selectedFedral.length == 0) {
                this.setState(
                    {
                        ...this.state,
                        canValidate: true
                    }
                )
                return
            }
            users.push(TenantService.get(TENANT.USER_ID))
            ReportService.apiConfig = {
                startDate: this.state.startDate,
                endDate: this.state.endDate
            }
            ReportService.downloadForm(users, this.formType, {}).then(
                (response) => {

                    saveAs(response, fileName);
                }, (error) => {
                    showToast("Internal Server Error", TOAST_TYPE.FAILURE);
                }
            )
        }

    }
    setQuarterAccountDetails() {
        let year = this.state.year[this.selectedYear[0]]

        let startDate = moment().year(year).startOf('quarter').format(this.requiredFormat);
        let endDate =  moment().month(year).endOf('quarter').format(this.requiredFormat);
        this.setState({
            ...this.state,
            startDate: startDate,
            endDate: endDate,
            canValidate: true
        })
    }
    render(){
        return(
            <div className="parent-width">
                <DKLabel text="Form 944" className="fw-m fs-l" />
                <div className="bg-white pb-l card-shadow mt-l">
                    <DKLabel text="Form 944 for Employer's" className="fw-m fs-l p-l" />
                    <DKLine  className="bg-gray3  "/>
                    <div className="d-flex p-h-l ">
                        { <div className="pr-l" style={{width:'35%'}}>

                        <DKInput
                            title="Year"
                            value={this.selectedYear}
                            type={INPUT_TYPE.SELECT}
                            required={true}
                            canValidate={this.state.canValidate}
                            readOnly={false}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={this.state.year}
                            errorMessage="Please select year"
                            onChange={(value)=>{

                                this.selectedYear = value


                                if(value.length != 0) {
                                    this.setQuarterAccountDetails()
                                } else {
                                    this.setState({...this.state,canValidate:true})
                                }

                            }}
                            />
                        </div>}



                        <div className={`mb-xs ${this.isAdmin ? 'mr-l': ''}` } style={{marginTop: '25px'}}>
                            <DKButton
                            title="DOWNLOAD FORM"
                            icon={DKIcons.white.ic_download}
                            className={`bg-app text-white ${this.isAdmin ? 'ml-l': ''}` }
                            onClick={()=>{
                                this.export();
                            }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}